import { __decorate } from "tslib";
import { AccessGuard, accessGuardData, provideRootRoutes } from '@core/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { UserRole } from '@core/shared/access';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let AbilitiesFrontendAdminFeature = /*#__PURE__*/(() => {
  let AbilitiesFrontendAdminFeature = class AbilitiesFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/abilities/frontend-admin","featureId":"common-abilities"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Skillsets',
          routerLink: 'abilities/skillsets',
          icon: 'lock',
          priority: 9,
          simpleAbilityCheck: UserRole.ADMINISTRATOR
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵAbilitiesFrontendAdminFeature_BaseFactory;
        return function AbilitiesFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵAbilitiesFrontendAdminFeature_BaseFactory || (ɵAbilitiesFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(AbilitiesFrontendAdminFeature)))(__ngFactoryType__ || AbilitiesFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: AbilitiesFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'abilities',
          data: {
            ...accessGuardData({
              allow: [UserRole.ADMINISTRATOR]
            })
          },
          canActivate: [AccessGuard],
          loadChildren: () => import('./abilities-admin.module').then(m => m.AbilitiesFrontendAdminModule)
        }])
        // provideFeatureAddonRoutes([])
        ]
      });
    }
  };
  AbilitiesFrontendAdminFeature = __decorate([ClassName("AbilitiesFrontendAdminFeature")], AbilitiesFrontendAdminFeature);
  return AbilitiesFrontendAdminFeature;
})();
export { AbilitiesFrontendAdminFeature };